import { render, staticRenderFns } from "./List.vue?vue&type=template&id=7a4d1e52&scoped=true"
import script from "./List.vue?vue&type=script&lang=ts"
export * from "./List.vue?vue&type=script&lang=ts"
import style0 from "./List.vue?vue&type=style&index=0&id=7a4d1e52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../nhaphangtocdo/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4d1e52",
  null
  
)

export default component.exports